import React from 'react';
import { Reveal } from '../../../elements/Reveal/Reveal';

import "./ProofStrip.scss";

export const ProofStrip = (props)=>{
    const { items } = props;

    return (
        <article className="ProofStrip">
            <ul>
                {items.map((item, index)=>(
                    <Reveal as="li" key={item} delay={index * 40}>
                        <span>{item}</span>
                    </Reveal>
                ))}
            </ul>
        </article>
    )
}
